/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { isEmpty } from "~/tools";

function concatText(entry: string, text: string) {
  return isEmpty(text) ? entry : entry.concat(" ", text);
}

export function generateActionSuccessText(item: string) {
  return (verb = "has") => {
    return (action: string) => {
      return (rest = "") => {
        const baseText = `${item} ${verb} been ${action}`;

        return `${concatText(baseText, rest)}.`;
      };
    };
  };
}

export function generateActionConfirmText(item: string) {
  return (action: string) => {
    return (rest = "") => {
      const baseText = `Are you sure you want to ${action} ${item}`;

      return `${concatText(baseText, rest)}?`;
    };
  };
}
